import ActiveDeactiveDialogConfirmation from 'components/ActiveDeactiveDialogConfirmation'
import { FilterMatchMode } from 'primereact/api'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable, DataTableValue } from 'primereact/datatable'
import { InputText } from 'primereact/inputtext'
import { Tag } from 'primereact/tag'
import { MouseEvent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ToastContent, toast } from 'react-toastify'
import { addUsersData, deleteUsersData, getUsersData } from 'services/userService'
import { PERMISSION_DENIED_MESSAGE } from "../../constants/index";
import { useDispatch, useSelector } from 'react-redux'
import { handleLoader, handleNotFound } from 'redux/counterSlice'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { datatableEdit, datatableEditHover } from 'assets/icons'
import { Sidebar } from 'primereact/sidebar'
import { useForm } from 'react-hook-form'

const Users = () => {
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
        clearErrors
    } = useForm<any>()
    const permissions = useSelector((state: any) => state.persistent.user_permissions);
    const [userList, setUserList] = useState<DataTableValue[]>([])
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState<{ [s: string]: any }>();
    const [deleteItems, setDeleteItems] = useState<{ for_active: boolean, users: [] }>({ for_active: true, "users": [] })
    const [selectedProducts, setSelectedProducts] = useState<Record<string, any>>();
    const [active, setActive] = useState<boolean>()
    const [first, setFirst] = useState(0); // State to control the first page
    const [sortField, setSortField] = useState(""); // State to control the first page
    const [sortOrder, setSortOrder] = useState<any>(""); // State to control the first page
    const [rowsPerPage, setRowsPerPage] = useState(5); // State to control the rows per page

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const fetchUserData = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getUsersData()
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result?.error
            }
            setUserList(result)
            dispatch(handleLoader(false));
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const getSeverity = (status: string) => {
        switch (status) {
            case 'Active':
                return 'success';

            case 'Inactive':
                return 'warning';
        }
    };

    const onClear = () => {
        setSelectedProducts(undefined);
        setDeleteItems({ for_active: true, "users": [] });
        setActive(false)
    }

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFirst(0);
        const value = e?.target?.value;
        let _filters = { ...filters };

        _filters['global']!.value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    const handleSort = (event: any) => {
        setSortField(event.sortField)
        setSortOrder(event.sortOrder)
        setFirst(0);  //Move to page 1
        // dispatch(setFirstVoice(0)); // Move to page 1
    };
    const onDeleteClick = (e: MouseEvent<HTMLSpanElement, globalThis.MouseEvent>, { email, isActive }: { email: string, isActive: boolean }) => {
        e.stopPropagation();
        setDeleteItems((prevState: any) => ({ ...prevState, for_active: !isActive, users: [...prevState.users, email] }))
        setActive(!isActive)
    }

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue('');
    };

    const setDeleteUserList = async (isActive: boolean) => {
        if (selectedProducts?.length > 0) {
            selectedProducts?.forEach((element: any) => {
                setDeleteItems((prevState: any) => ({ ...prevState, for_active: isActive, users: [...prevState.users, element.email] }))
            });
            setActive(isActive)
        } else {
            toast.error("Please select at least one user to update the status", {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const deleteUsers = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await deleteUsersData(deleteItems)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            fetchUserData()
            toast.success(result.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            onClear()
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    useEffect(() => {
        dispatch(handleNotFound(false))
        fetchUserData()
        initFilters()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [is_hover_Edit, setIs_hover_Edit] = useState<string>("");

    const [visible, setVisible] = useState<boolean>(false);
    const customHeader = (
        <div className="flex align-items-center gap-2">
            Add User
        </div>
    );
    const getFormErrorMessage = (name: string) => {
        return (
            errors[name] && (
                <small className="p-error">{errors[name]?.message?.toString()}</small>
            )
        )
    }
    const onCancel = () => {
        setValue("firstName", "");
        setValue("lastName", "");
        setValue("email", "");
        setVisible(false);
        clearErrors();
    }
    const onSubmit = async (data: { email: string, firstName: string, lastName: string }) => {
        if (permissions.add) {
            dispatch(handleLoader(true));
            try {
                let result: any = await addUsersData({ ...data, update: false })
                if (result?.result?.error) {
                    throw result.result.error
                }
                setVisible(false)
                await fetchUserData();
                dispatch(handleLoader(false));
                toast.success(result.result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            } catch (error) {
                dispatch(handleLoader(false));
                toast.error(error as ToastContent<unknown>, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        } else {
            toast.error(PERMISSION_DENIED_MESSAGE, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    return (
        <>
            <div className="datatable-wrapper">
                <div className='p-4 content-wrapper'>
                    <div className="switch-section user-management-section">
                        <div className='d-flex align-items-center justify-content-between flex-wrap mb-3 table-top-row'>
                            <h4 className="mb-0">User Management</h4>
                            <div className="d-flex justify-content-between align-items-center table-right-row">
                                <div className='d-flex align-items-center table-right-first'>
                                    <div className='d-flex align-items-center table-search mr-3 mt-1 mb-1'>
                                        <IconField iconPosition="right" className='user-input'>
                                            <InputIcon className="pi pi-search"></InputIcon>
                                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search by user details" />
                                        </IconField>
                                    </div>
                                    {permissions.add &&
                                        <Button label="Add User" outlined icon="pi pi-plus" className='outline-icon-btn mr-3 mt-1 mb-1'
                                            onClick={() => setVisible(true)}
                                        // onClick={async () => {navigate('/admin/users/add')}}
                                        ></Button>
                                    }
                                </div>
                                {permissions.delete &&
                                    <div className='table-right-end mt-1 mb-1'>
                                        <Button className='outline-icon-btn grey-outline-btn active-btn mr-3' outlined label='Active' data-bs-toggle={permissions.delete && (selectedProducts && selectedProducts !== null && selectedProducts.length !== 0) && "modal"} data-bs-target={permissions.delete && "#active-deactive"} onClick={() => setDeleteUserList(true)}></Button>
                                        <Button className='outline-icon-btn grey-outline-btn inactive-btn' outlined label='Inactive' data-bs-toggle={permissions.delete && (selectedProducts && selectedProducts !== null && selectedProducts.length !== 0) && "modal"} data-bs-target={permissions.delete && "#active-deactive"} onClick={() => setDeleteUserList(false)}></Button>
                                    </div>
                                }
                            </div>
                        </div>
                        <DataTable
                            selection={selectedProducts}
                            selectionPageOnly
                            onSelectionChange={(e) => { setSelectedProducts(e.value) }}
                            paginator
                            filters={filters}
                            globalFilterFields={['firstName', 'lastName', 'email']}
                            first={first}
                            onPage={(e) => { setFirst(e.first); setRowsPerPage(e.rows) }}
                            rows={rowsPerPage}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            sortMode="single"
                            onSort={handleSort}
                            rowsPerPageOptions={[5, 10, 25]}
                            stripedRows
                            value={userList}
                            tableStyle={{}}
                            emptyMessage="No user records found"
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                            <Column field="firstName" header="First Name" sortable ></Column>
                            <Column field="lastName" header="Last Name" sortable ></Column>
                            <Column field="email" header="Email" sortable ></Column>
                            {/* <Column field="isActive" header="Active/DisActive" body={(rowData) => (<input checked={rowData.isActive} onChange={() => onDeleteClick(rowData)} className="form-check-input" type="checkbox" role="switch" />)}></Column> */}
                            {/* <Column field="isActive" header="Active/DisActive" body={(rowData) => (<i className={classNames('pi', { 'text-green-500 pi-check-circle': rowData.isActive, 'text-red-500 pi-times-circle': !rowData.isActive })}  onClick={(e) => { onDeleteClick(e,rowData) }}></i>)}></Column> */}
                            <Column field="status" header="Status" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} body={(rowData) => (<Tag data-bs-toggle={permissions.delete && "modal"} data-bs-target={permissions.delete && "#active-deactive"}
                                onClick={(e) => {
                                    permissions.delete ? onDeleteClick(e, rowData) : toast.error(PERMISSION_DENIED_MESSAGE, {
                                        style: {
                                            backgroundColor: '#F1F1F1', // Grey background
                                        }
                                    })
                                }}
                                value={rowData.isActive ? 'Active' : 'Inactive'}
                                severity={getSeverity(rowData.isActive ? 'Active' : 'Inactive')}
                                className={rowData.isActive ? 'status-tag active' : 'status-tag inactive'}
                            />)} />
                            <Column header="Action" body={(rowData) => (<div><span onClick={(e) => {
                                permissions.edit ? navigate(`/admin/users/${rowData.id}`) : toast.error(PERMISSION_DENIED_MESSAGE, {
                                    style: {
                                        backgroundColor: '#F1F1F1', // Grey background
                                    }
                                })
                            }} onMouseEnter={() => setIs_hover_Edit(rowData.id)} onMouseLeave={() => setIs_hover_Edit("")}>
                                <img src={is_hover_Edit === rowData.id ? datatableEditHover : datatableEdit} alt='edit-icon' />
                            </span></div>)}></Column>
                        </DataTable>
                    </div>
                </div>
            </div>
            {/* <ActiveDeactiveDialogConfirmation active={active!} visible={showDeleteDialogBox} onHide={setShowDeleteDialogBox} changeStatus={deleteUsers} onCancel={onClear} /> */}
            <ActiveDeactiveDialogConfirmation active={active!} changeStatus={deleteUsers} onCancel={onClear} />
            <Sidebar position="right" header={customHeader} visible={visible} onHide={onCancel} className='form-sidebar'>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-sidebar-body">
                        <div className='form-row'>
                            <div className='form-col'>
                                <label className="form-label">First Name<i>*</i></label>
                                <InputText
                                    className="form-control"
                                    {...register("firstName", {
                                        required: {
                                            value: true,
                                            message: "First name is required",
                                        },
                                    })}
                                    placeholder="First Name"
                                />
                                {getFormErrorMessage("firstName")}
                            </div>
                        </div>
                        <div className='form-row'>
                            <div className='form-col'>
                                <label className="form-label">Last Name<i>*</i></label>
                                <InputText
                                    className="form-control"
                                    {...register("lastName", {
                                        required: {
                                            value: true,
                                            message: "Last name is required",
                                        },
                                    })}
                                    placeholder="Last Name"
                                />
                                {getFormErrorMessage("lastName")}
                            </div>
                        </div>
                        <div className='form-row'>
                            <div className='form-col'>
                                <label className="form-label">Email<i>*</i></label>
                                <InputText
                                    className="form-control"
                                    type="email"
                                    {...register('email', {
                                        required: 'Email is required',
                                        pattern: {
                                            value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                            message: "Invalid email address"
                                        },
                                    })}
                                    placeholder="Email"
                                />
                                {getFormErrorMessage("email")}
                            </div>
                        </div>
                    </div>
                    <div className='form-sidebar-footer'>
                        <Button className='grey-outline-btn btn-lg' type='button' onClick={onCancel} label='Cancel'></Button>
                        <Button className='outline-active-btn btn-lg' type='submit' label='Save'></Button>
                    </div>
                </form>
            </Sidebar>
        </>
    )
}

export default Users